<template>
  <div>
    <h3>{{$t('ai_coding.form.code_articles.title')}}</h3>
    <p>{{$t('ai_coding.form.code_articles.text')}}</p>
    <div class="d-flex">
      <form-renderer
        id="ai-coding-models"
        :model="promptModel"
        :fields="fields"
        :showSubmit="false"
        formWrapperClass="d-flex flex-wrap"
        classForm="w-100"
        :syncModel="true"
        @updateModel="updatePromptModel"
      />
    </div>
    <div class="d-flex justify-content-end submit-btn">
      <div v-if="showPriorityQueueButton">
        <button type="submit" class="btn input-ui-sm btn btn-carma btn-save mt10 mr10" @click="() => $emit('submit', { ...this.promptModel, priority_queue: true })">
          {{$t('ai_coding.form.buttons.priority_queue')}}
        </button>
      </div>
      <div>
        <button type="submit" class="btn input-ui-sm btn btn-carma btn-save mt10 mr10" @click="() => $emit('submit', this.promptModel)">
          {{$t('form.button.continue')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormRenderer from '../form-renderer.vue';
import { FIELD_TYPE } from '../../config/const';

export default {
    components: {
      FormRenderer
    },
    data() {
      return {
        promptModel: {
          priority_queue: false,
          model_ids: []
        }
      }
    },
    mounted () {
      Promise.all([
        this.fetchPrompt(),
        this.getUserPreferences({ name: 'ai_coding_apply_default_models', projectId: this.projectId })
      ]).then(() => {
        this.updatePromptModel({ model_ids: this.preSelectedModels });
      })
    },

    computed: {
      ...mapState({
        aiCodingData: state => state?.aiCoding?.aiCoding?.data,
        isAiCodingBusy: state => state?.aiCoding?.aiCoding?.isBusy,
        aiProviders: state => state.carmaAi?.carmaAi?.aiProviders?.data || [],
        preferences: state => state?.user?.preferences,
        project: state => state.projects.project.data || {},
        user: state => state.user.user.data || {},
      }),
      projectId () {
        return this.$route.params.project_uid;
      },
      fields () {
        return [
          {
            key: 'model',
            id: 'model',
            name: 'model_ids',
            searchable: true,
            multiple: true,
            label: this.$t('ai_coding.fields.model'),
            type: FIELD_TYPE.SELECT,
            options: this.modelOptions,
            customClass: 'mr10',
            allowEmpty: true,
            selectAllTooltipMessage: this.$t('form.tooltip.select_all'),
            clearAllTooltipMessage: this.$t('form.tooltip.clear_selection'),
            style: 'width: 50%',
            translate_label_tooltip: 'ai_coding.message.model_tooltip',
            events: {
              saveSelection: this.onSaveSelectedModels
            }
          },
        ]
      },

      defaultModels () {
        return this.preferences?.ai_coding_apply_default_models?.value || [];
      },

      modelOptions () {
        const options = (this.aiCodingData || []).map(m => ({ label: m?.prompt_key + ' ' + m?.name , value: m?.id }));
        options.push(this.defaultModels);
        return options.filter((dt, i, arr) => arr.findIndex(t => t.value === dt.value) === i);
      },

      preSelectedModels () {
        if (this.defaultModels.length > 0) {
          return this.defaultModels.map(dt => dt.value);
        } else if (Array.isArray(this.aiCodingData)) {
          return this.aiCodingData.reduce((acc, m) => {
              if(m?.allow_ai) acc = [...acc, m.id];
              return acc;
          }, []);
        }
        return [];
      },

      showPriorityQueueButton () {
        return this.project.enable_analysis_article_priority_queue && this.user.permissions.analysis_aricle_priority_queue;
      }
    },
    methods: {
    ...mapActions({
      getPrompt: 'aiCoding/getPrompt',
      getUserPreferences: 'user/getUserPreferences',
      updateUserPreferences: 'user/updateUserPreferences',
    }),
    findModelProvider (model) {
      return this.aiProviders.find(item => item.model === model)?.provider;
    },
    updatePromptModel (model, field) {
      this.promptModel = { ...model };
    },
    fetchPrompt () {
      return this.getPrompt({ projectId: this.projectId });
    },
    onSaveSelectedModels (value) {
      if (value) {
        this.updateUserPreferences({ name: 'ai_coding_apply_default_models', projectId: this.projectId, settings: { value } }).then(r => {
          this.$notify({
            group: 'store_notifications',
            type: 'success',
            text: this.$t('ai_coding.message.default_models'),
          });
        });
      }
    }
  }
}
</script>

<style scoped>
  .submit-btn{
    position: absolute;
    bottom: 1rem;
    right: 1rem;
  }
</style>